import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { styled } from '@mui/system';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { useTranslation } from '@hooks';
import { OPTIMIZATION_BUCKET, OPTIMIZATION_BUCKET_LEVELS } from '@constants/companies';
import { RoutePath } from '@constants/routes';
import MetricItem from './MetricItem';

const CardsWrapper = styled('div')({
    display: 'grid',
    gridGap: 16,
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    height: 'calc(100% - 57px)',
    '@media (max-width: 375px)': {
        gridTemplateColumns: 'repeat(1, 1fr)',
    },
});

const HighIcon = styled(CheckCircleIcon)({ color: '#4CC474' });
const MediumIcon = styled(ErrorIcon)({ color: '#FFA949' });
const LowIcon = styled(CancelIcon)({ color: '#FF5853' });

const linkTo = bucket =>
    `${RoutePath.LocationsManage}?completenessLevels=${encodeURIComponent(
        JSON.stringify(OPTIMIZATION_BUCKET_LEVELS[bucket]),
    )}`;

const OptimizationScore = () => {
    const { t } = useTranslation();
    const { optimizationScore } = useSelector(state => state.dashboard.dashboard);
    const loaded = useSelector(state => state.dashboard.loaded);
    const navigate = useNavigate();

    const data = [
        {
            id: 0,
            title: t('common.high'),
            value: optimizationScore.high,
            icon: <HighIcon />,
            onClick: () => navigate(linkTo(OPTIMIZATION_BUCKET.HIGH)),
        },
        {
            id: 1,
            title: t('common.medium'),
            value: optimizationScore.medium,
            icon: <MediumIcon />,
            onClick: () => navigate(linkTo(OPTIMIZATION_BUCKET.MEDIUM)),
        },
        {
            id: 2,
            title: t('common.low'),
            value: optimizationScore.low,
            icon: <LowIcon />,
            onClick: () => navigate(linkTo(OPTIMIZATION_BUCKET.LOW)),
        },
    ];

    return (
        <CardsWrapper>
            {data.map(item => (
                <MetricItem
                    key={item.id}
                    value={item.value}
                    title={item.title}
                    withBorder
                    Icon={item.icon}
                    onClick={item.onClick}
                    loading={!loaded}
                />
            ))}
        </CardsWrapper>
    );
};

export default OptimizationScore;
